









import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { defineComponent } from '@nuxtjs/composition-api'
import { ciStar } from '~/icons/source/regular/start'

export default defineComponent({
  components: { CBadge },
  setup() {
    return { ciStar }
  }
})
